import React, { useMemo } from "react";
import * as echarts from "echarts";
import { default as EchartsWrapper } from "src/components/Echarts";
import { getSubscribeBitrateChartConfiguration } from "../../helpers/getSubscribeConfigurations";
type echartsOptions = echarts.EChartsOption;

export const SubscriberBitrateChart = ({
  publishData,
  loading,
}: {
  publishData: any;
  loading: boolean;
}) => {
  const peerSubscriberBitrateChartoptions: echartsOptions = useMemo(
    () => getSubscribeBitrateChartConfiguration(publishData),
    [publishData]
  );

  return (
    <>
      {/* @ts-ignore */}
      <EchartsWrapper
        options={{ ...peerSubscriberBitrateChartoptions }}
        loading={loading}
        style={{ height: "240px", width: "auto" }}
      />
    </>
  );
};
